<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div class="flex justify-content-space-between align-items marginBottom20">
          <div class="flex align-items">
            <div class="width200 marginRight10">
              <el-input
                v-model="searchData.name"
                placeholder="输入姓名/手机号"
                @keyup.enter.native="handleSearch"
                clearable
                maxlength="20"
              ></el-input>
            </div>
            <div class="width200">
              <el-input
                v-model="searchData.position"
                placeholder="输入职位"
                @keyup.enter.native="handleSearch"
                clearable
                maxlength="50"
              ></el-input>
            </div>
            <el-button
              size="medium"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              class="marginLeft10"
            >查询</el-button>
            <el-button
              size="medium"
              type="info"
              icon="el-icon-refresh-right"
              @click="handleReset"
              class="marginLeft10"
            >重置</el-button>
          </div>

          <el-button
            size="medium"
            type="primary"
            icon="el-icon-plus"
            @click="handleCreate"
          >新增开锁人员</el-button>
        </div>
      </template>
      <template
        slot="menu"
        slot-scope="{ row }"
      >
        <el-button
          type="text"
          size="mini"
          @click="handleUrl(row)"
        >开锁记录</el-button>
        <el-button
          type="text"
          size="mini"
          @click="handleEdit(row)"
        >编辑</el-button>
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(row)"
        >删除</el-button>
      </template>
      <!-- 区域挂载 -->
      <template
        slot="whiteUseScope"
        slot-scope="{ row }"
      >
        <el-button
          v-if="row.whiteUseScope === 2"
          type="text"
          size="mini"
          @click="handleLook(row)"
        >查看</el-button>
        <div v-else>全区域</div>
      </template>
      <!-- 状态挂载 -->
      <template
        slot="whiteState"
        slot-scope="{ row }"
      >
        <el-switch
          v-model="row.whiteState"
          :inactive-value="2"
          :active-value="1"
          @change="handleSwitch($event, row.id)"
        ></el-switch>
      </template>
    </avue-crud>

    <el-dialog
      v-if="dialogVisible1"
      title="区域列表"
      :visible.sync="dialogVisible1"
      width="800px"
      :before-close="handleClose1"
    >
      <avue-crud
        :data="tableData1"
        :option="option1"
        :table-loading="showLoading1"
      >
      </avue-crud>
    </el-dialog>
  </div>
</template>

<script>
import {
  whiteList,
  whiteStateUpdate,
  regionList,
  deleteWhite,
} from "@/api/scan/index";
export default {
  name: "index",
  data() {
    return {
      disabled: false,
      searchData: {
        name: "",
        position: "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      option: {
        title: "白名单设置",
        titleSize: "h3",
        card: true,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "姓名",
            prop: "whiteUsername",
          },
          {
            label: "联系电话",
            prop: "whitePhone",
          },
          {
            label: "职位",
            prop: "position",
          },
          {
            label: "区域",
            prop: "whiteUseScope",
          },
          {
            label: "状态",
            prop: "whiteState",
          },
          {
            label: "创建时间",
            prop: "whiteCreateTime",
          },
        ],
      },

      // 弹出表格
      dialogVisible1: false,
      tableData1: [],
      showLoading1: false,
      option1: {
        title: "",
        titleSize: "h3",
        card: true,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: false, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
          {
            label: "区域编号",
            prop: "code",
          },
          {
            label: "区域名称",
            prop: "name",
          },
          {
            label: "状态",
            prop: "state",
            formatter: function (row, column, cellValue) {
              return row.state === 1 ? "正常" : row.state === 2 ? "冻结" : "/";
            },
          },
        ],
      },
    };
  },
  created() {
    const searchForm = JSON.parse(localStorage.getItem("searchForm"));
    if (searchForm?.path === this.$route.path) {
      this.searchData = searchForm.searchData;
    } else {
      localStorage.removeItem("searchForm");
    }
  },
  methods: {
    // 跳转开锁记录
    handleUrl(row) {
      this.$router.push({
        path: "/scan/white/open",
        query: {
          id: row.id,
        },
      });
    },
    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteWhite({
          id: row.id,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    // 区域查看方法
    handleLook(row) {
      this.dialogVisible1 = true;
      console.log(row);
      this.tableData1 = [];
      this.showLoading1 = true;
      regionList({ id: row.id }).then((res) => {
        this.showLoading1 = false;
        if (res.code === 200) {
          this.tableData1 = res.data;
        }
      });
    },
    // 白名单状态切换
    handleSwitch(event, id) {
      whiteStateUpdate({
        id: id,
        whiteState: event,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.msg);
        }
        this.onLoad();
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      localStorage.removeItem("searchForm");
      // console.log('重置')
      this.searchData = {
        name: "",
        position: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      localStorage.setItem("searchForm", JSON.stringify(searchForm));
      this.showLoading = true;
      whiteList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },
    // 添加
    handleCreate() {
      this.$router.push({
        path: "/scan/white/create",
        query: {
          type: "create",
        },
      });
    },
    handleEdit(row) {
      this.$router.push({
        path: "/scan/white/create",
        query: {
          type: "edit",
          id: row.id,
        },
      });
    },
    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteWhite({
          id: row.id,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            this.onLoad();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },

    // 表格弹出关闭
    handleClose1() {
      this.dialogVisible1 = false;
    },
  },
};
</script>

<style scoped></style>
